import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";

import { baseUrl } from "../../../constants";
import { apiClient } from "../../api";
import { GET_PASSENGERS_API_RESPONSE, UploadPassengerPayload } from "./types";
import keys from "./keys";

const passengersResourcePath = "trips/:businessId/passengers";

const useGetPassengers = (businessId: string, url: string) => {
  const getUsersUrl = url.replace(":businessId", businessId);
  const hash = [keys.read, getUsersUrl];
  const {
    isLoading,
    data,
    isSuccess,
    error,
  }: UseQueryResult<GET_PASSENGERS_API_RESPONSE, unknown> = useQuery(
    hash,
    () => apiClient.get({ url: getUsersUrl }),
    {
      enabled: !!businessId,
    },
  );
  return { isLoading, data, isSuccess, error };
};

// const useGetPassenger = (id: string | undefined) => {
//   const hash = [keys.read, `${id}`];
//   const {
//     isLoading,
//     data,
//     isSuccess,
//     error,
//   }: UseQueryResult<GET_PASSENGER_API_RESPONSE, unknown> = useQuery(
//     hash,
//     () => apiClient.get({ url: `${baseUrl}/trips/${id}` }),
//     {
//       enabled: !!id,
//     },
//   );
//   return { isLoading, data, isSuccess, error };
// };

const useUploadPassenger = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      businessId,
      data,
    }: {
      businessId: string;
      data: UploadPassengerPayload;
    }) => {
      if (!businessId) {
        throw new Error("Business ID is required");
      }

      const uploadUrl = `${passengersResourcePath}/upload`;
      const path = uploadUrl.replace(":businessId", businessId);

      // Build FormData for file upload
      const formData = new FormData();
      formData.append("file", data.file);

      const response = await apiClient.post({
        url: `${baseUrl}/${path}`,
        body: formData,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [keys.read],
      });
    },
  });
};

export { passengersResourcePath, useGetPassengers, useUploadPassenger };
